import { useLocation, useNavigate } from 'react-router-dom';
import { Menu as MenuIcon, FolderPlus, UploadCloud } from 'lucide-react';
import SearchBar from '../search/SearchBar';
import NotificationBell from './NotificationBell';
import PermissionGuard from '../common/PermissionGuard';
import { useUploads } from '../../context/UploadContext';
import { P } from '../../utils/permissions';

/**
 * v2 top bar: hamburger (mobile), global search, then New folder / Upload on the right.
 * The two actions route into the current document context via a query flag that the
 * browser screen consumes (see DocumentBrowser).
 */
export default function Topbar({ onOpenNav }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeCount, overallProgress } = useUploads();

  // Stay inside the folder the user is looking at; otherwise fall back to their documents.
  const inBrowser = location.pathname.startsWith('/documents') || location.pathname.startsWith('/departments');
  const target = inBrowser ? location.pathname : '/documents';

  const trigger = (action) => navigate(`${target}?action=${action}`);

  return (
    <header className="topbar">
      <button type="button" className="btn btn--secondary topbar__menu" onClick={onOpenNav} aria-label="Open navigation">
        <MenuIcon size={20} />
      </button>

      <SearchBar />

      <div className="topbar__actions">
        <NotificationBell />

        <PermissionGuard permission={P.FOLDER_CREATE}>
          <button type="button" className="btn btn--secondary topbar__newfolder" onClick={() => trigger('new-folder')}>
            <FolderPlus size={16} className="mobile-only" />
            <span className="desktop-only">New folder</span>
          </button>
        </PermissionGuard>

        <PermissionGuard permission={P.DOCUMENT_UPLOAD}>
          <button
            type="button"
            className="btn btn--primary"
            onClick={() => trigger('upload')}
            title={activeCount ? `${activeCount} uploading — ${overallProgress}%` : undefined}
          >
            <UploadCloud size={16} strokeWidth={2.2} />
            {activeCount ? `Uploading ${overallProgress}%` : 'Upload'}
          </button>
        </PermissionGuard>
      </div>
    </header>
  );
}
